// Recovered verbatim from the original Bullish site (fees omitted).
const plans = {
 "es": [
  {
   "id": "basic",
   "name": "Basic",
   "subtitle": "Contabilidad anual – Cumplimiento básico",
   "description": "Contabilidad anual y cumplimiento fiscal para empresas con bajo volumen de transacciones. Diseñado para empresas que buscan cumplimiento anual sin necesidad de contabilidad mensual continua.",
   "idealFor": [
    "Empresas con bajo volumen de transacciones",
    "Negocios pequeños o recién formados",
    "Empresas que solo requieren cumplimiento anual",
    "Negocios sin necesidad de contabilidad mensual"
   ],
   "bookkeepingServices": [
    "Registro y organización anual de ingresos y gastos",
    "Revisión de transacciones y clasificación por categoría fiscal",
    "Reconciliación de una (1) cuenta bancaria",
    "Ajustes de fin de año requeridos para reportes fiscales",
    "Preparación de estados financieros para propósitos fiscales (Estado de Resultados y Balance General)"
   ],
   "taxServices": [
    "Revisión de información financiera previa a la preparación de impuestos",
    "Preparación y presentación de una declaración federal de impuestos",
    "Preparación y presentación de una declaración estatal de impuestos",
    "Coordinación entre contabilidad y declaración fiscal para asegurar consistencia"
   ]
  },
  {
   "id": "basic-plus",
   "name": "Basic Plus",
   "subtitle": "Contabilidad anual – Cumplimiento ampliado",
   "description": "Contabilidad anual y cumplimiento fiscal para empresas con mayor volumen de transacciones. Diseñado para empresas que buscan cumplimiento anual sin necesidad de contabilidad mensual continua.",
   "idealFor": [
    "Empresas con mayor volumen de transacciones",
    "Negocios con actividad operacional incrementada",
    "Empresas que requieren cumplimiento anual pero no necesitan contabilidad mensual",
    "Negocios en crecimiento que han superado el paquete básico anual"
   ],
   "bookkeepingServices": [
    "Registro y organización anual de ingresos y gastos",
    "Revisión de transacciones y clasificación por categoría fiscal",
    "Reconciliación de múltiples cuentas bancarias, según volumen de transacciones",
    "Procesamiento de mayor volumen de transacciones",
    "Ajustes de fin de año requeridos para reportes fiscales",
    "Preparación de estados financieros para propósitos fiscales (Estado de Resultados y Balance General)"
   ],
   "taxServices": [
    "Revisión de información financiera previa a la preparación de impuestos",
    "Preparación y presentación de una declaración federal de impuestos",
    "Preparación y presentación de una declaración estatal de impuestos",
    "Coordinación entre contabilidad y declaración fiscal para asegurar consistencia"
   ]
  },
  {
   "id": "quarterly",
   "name": "Quarterly",
   "subtitle": "Contabilidad trimestral y cumplimiento",
   "description": "Contabilidad trimestral y cumplimiento fiscal para empresas que se benefician de revisiones financieras periódicas y contabilidad trimestral, sin necesidad de contabilidad mensual.",
   "idealFor": [
    "Empresas con volumen de transacciones moderado a alto",
    "Negocios que requieren supervisión financiera periódica",
    "Empresas que buscan más estructura que la contabilidad anual",
    "Negocios que desean revisiones trimestrales sin contabilidad mensual"
   ],
   "bookkeepingServices": [
    "Registro y organización trimestral de ingresos y gastos",
    "Revisión de transacciones y clasificación por categoría fiscal",
    "Reconciliación de múltiples cuentas bancarias, según volumen de transacciones",
    "Revisión financiera trimestral y limpieza",
    "Ajustes de fin de año requeridos para reportes fiscales",
    "Preparación de estados financieros trimestrales y de fin de año para propósitos fiscales (Estado de Resultados y Balance General)"
   ],
   "taxServices": [
    "Revisión de información financiera previa a la preparación de impuestos",
    "Preparación y presentación de una declaración federal de impuestos",
    "Preparación y presentación de una declaración estatal de impuestos",
    "Coordinación entre contabilidad y declaración fiscal para asegurar consistencia",
    "Coordinación y orientación relacionada con pagos estimados federales, cuando aplique"
   ],
   "meetings": [
    "Una reunión de revisión trimestral programada para discutir resultados financieros y consideraciones fiscales"
   ]
  },
  {
   "id": "monthly",
   "name": "Monthly",
   "subtitle": "Contabilidad mensual y cumplimiento",
   "description": "Contabilidad mensual y cumplimiento fiscal para empresas que requieren supervisión financiera continua y reportes consistentes durante todo el año. Diseñado para empresas que necesitan soporte de contabilidad continuo, reportes financieros mensuales y coordinación fiscal permanente.",
   "idealFor": [
    "Empresas con alto volumen de transacciones",
    "Negocios que requieren supervisión financiera continua",
    "Empresas que necesitan información financiera oportuna y consistente",
    "Negocios que han superado la contabilidad trimestral"
   ],
   "bookkeepingServices": [
    "Registro y organización mensual de ingresos y gastos",
    "Revisión continua de transacciones y clasificación por categoría fiscal",
    "Reconciliación de múltiples cuentas bancarias y tarjetas de crédito (según volumen de transacciones)",
    "Limpieza mensual e identificación de problemas",
    "Ajustes continuos según sea necesario durante todo el año",
    "Preparación de estados financieros mensuales y de fin de año para propósitos fiscales y gerenciales (Estado de Resultados y Balance General)"
   ],
   "taxServices": [
    "Revisión de información financiera previa a la preparación de impuestos",
    "Preparación y presentación de una declaración federal de impuestos",
    "Preparación y presentación de una declaración estatal de impuestos",
    "Coordinación entre contabilidad y declaración fiscal para asegurar consistencia",
    "Coordinación y orientación relacionada con pagos estimados federales (cuando aplique)"
   ],
   "meetings": [
    "Una reunión de revisión programada por trimestre",
    "Comunicación continua por email relacionada con los servicios incluidos en este paquete"
   ]
  }
 ],
 "en": [
  {
   "id": "basic",
   "name": "Basic",
   "subtitle": "Annual Bookkeeping – Basic Compliance",
   "description": "Annual bookkeeping and tax compliance for companies with low transaction volume. Designed for companies seeking annual compliance without ongoing monthly bookkeeping.",
   "idealFor": [
    "Companies with low transaction volume",
    "Small or newly formed businesses",
    "Companies that require annual compliance only",
    "Businesses without monthly bookkeeping needs"
   ],
   "bookkeepingServices": [
    "Annual recording and organization of income and expenses",
    "Transaction review and tax-category classification",
    "Reconciliation of one (1) bank account",
    "Year-end adjustments required for tax reporting",
    "Preparation of financial statements for tax reporting purposes (Profit & Loss and Balance Sheet)"
   ],
   "taxServices": [
    "Review of financial information prior to tax preparation",
    "Preparation and filing of one federal income tax return",
    "Preparation and filing of one state tax return",
    "Coordination between bookkeeping and tax filing to ensure consistency"
   ]
  },
  {
   "id": "basic-plus",
   "name": "Basic Plus",
   "subtitle": "Annual Bookkeeping – Enhanced Compliance",
   "description": "Annual bookkeeping and tax compliance for companies with higher transaction volume. Designed for companies seeking annual compliance without ongoing monthly bookkeeping.",
   "idealFor": [
    "Companies with higher transaction volume",
    "Businesses with increased operational activity",
    "Companies that require annual compliance but do not need monthly bookkeeping",
    "Growing businesses that have outgrown basic annual bookkeeping"
   ],
   "bookkeepingServices": [
    "Annual recording and organization of income and expenses",
    "Transaction review and tax-category classification",
    "Reconciliation of multiple bank accounts, based on transaction volume",
    "Increased transaction volume processing",
    "Year-end adjustments required for tax reporting",
    "Preparation of financial statements for tax reporting purposes (Profit & Loss and Balance Sheet)"
   ],
   "taxServices": [
    "Review of financial information prior to tax preparation",
    "Preparation and filing of one federal income tax return",
    "Preparation and filing of one state tax return",
    "Coordination between bookkeeping and tax filing to ensure consistency"
   ]
  },
  {
   "id": "quarterly",
   "name": "Quarterly",
   "subtitle": "Quarterly Bookkeeping & Compliance",
   "description": "Quarterly bookkeeping and tax compliance for companies that benefit from periodic financial reviews and quarterly bookkeeping, without the need for monthly accounting.",
   "idealFor": [
    "Companies with moderate to high transaction volume",
    "Businesses that require periodic financial oversight",
    "Companies seeking more structure than annual bookkeeping",
    "Businesses that want quarterly check-ins without monthly bookkeeping"
   ],
   "bookkeepingServices": [
    "Quarterly recording and organization of income and expenses",
    "Transaction review and tax-category classification",
    "Reconciliation of multiple bank accounts, based on transaction volume",
    "Quarterly financial review and cleanup",
    "Year-end adjustments required for tax reporting",
    "Preparation of quarterly and year-end financial statements for tax reporting purposes (Profit & Loss and Balance Sheet)"
   ],
   "taxServices": [
    "Review of financial information prior to tax preparation",
    "Preparation and filing of one federal income tax return",
    "Preparation and filing of one state tax return",
    "Coordination between bookkeeping and tax filing to ensure consistency",
    "Coordination and guidance related to federal estimated tax payments, when applicable"
   ],
   "meetings": [
    "One scheduled quarterly review meeting to discuss financial results and tax-related considerations"
   ]
  },
  {
   "id": "monthly",
   "name": "Monthly",
   "subtitle": "Monthly Bookkeeping & Compliance",
   "description": "Monthly bookkeeping and tax compliance for companies that require ongoing financial oversight and consistent reporting throughout the year. Designed for companies that require continuous bookkeeping support, monthly financial reporting, and ongoing tax compliance coordination.",
   "idealFor": [
    "Companies with high transaction volume",
    "Businesses that require continuous financial oversight",
    "Companies that need timely and consistent financial information",
    "Businesses that have outgrown quarterly bookkeeping"
   ],
   "bookkeepingServices": [
    "Monthly recording and organization of income and expenses",
    "Ongoing transaction review and tax-category classification",
    "Reconciliation of multiple bank and credit card accounts (based on transaction volume)",
    "Monthly cleanup and issue identification",
    "Ongoing adjustments as needed throughout the year",
    "Preparation of monthly and year-end financial statements for tax and management purposes (Profit & Loss and Balance Sheet)"
   ],
   "taxServices": [
    "Review of financial information prior to tax preparation",
    "Preparation and filing of one federal income tax return",
    "Preparation and filing of one state tax return",
    "Coordination between bookkeeping and tax filing to ensure consistency",
    "Coordination and guidance related to federal estimated tax payments (when applicable)"
   ],
   "meetings": [
    "One scheduled review meeting per quarter",
    "Ongoing email communication related to the services included in this package"
   ]
  }
 ]
};

export default plans;
